import classcat from "classcat";
import React from "react";

import { IconSearch } from "@touchtech/web-baselayer-ui";

import css from "./SearchButton.module.css";
import useManageSearchButton from "./hooks/useManageSearchButton";

type Props = {
  onClick: () => void;
  className?: string;
  isVisible: boolean;
};

const SearchButton = ({ onClick, className, isVisible }: Props) => {
  const { show } = useManageSearchButton({ isVisible });

  return (
    <button
      className={classcat([css.searchButton, { [css.show]: show }, className])}
      onClick={onClick}
    >
      <IconSearch className={css.searchIcon} />
    </button>
  );
};

export default SearchButton;
